/** Matches event_engine_schemas Page universal-template module shape.
 *  Only the sub-object relevant to `type` is included. */
const MODULE_DEFAULTS = {
  hero: { img: '', url: '', alt: '' },
  text: { content: '' },
  form: { url: '', form_name: '' }
}

export const createEmptyUniversalModule = type => ({
  type,
  [type]: MODULE_DEFAULTS[type]
})
